module.exports = __webpack_public_path__ + "media/images/btn_see_bookings_as_cover_owner-3abd0d4b8b04d96489b8e451b92a09f7.gif";